import React, { useState } from 'react';
import { useSelector } from 'react-redux';

const AddressSelector = ({ selectedAddress, onSelect }) => {
  const { addresses } = useSelector((state) => state.address);
  const [showModal, setShowModal] = useState(false);
  const [search, setSearch] = useState('');

  const filtered = addresses.filter((a) =>
    a.addressline1.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-600">Address</label>
      <input
        type="text"
        readOnly
        value={selectedAddress?.addressline1 || ''}
        onClick={() => setShowModal(true)}
        className="w-full px-4 py-2 border rounded cursor-pointer bg-gray-50"
        placeholder="Select Address"
      />

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded w-96 max-h-[80vh] overflow-y-auto">
            <h3 className="text-xl font-bold mb-2">Select Address</h3>
            <input
              className="w-full mb-3 px-3 py-2 border rounded"
              placeholder="Search address..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <ul className="space-y-2">
              {filtered.map((addr) => (
                <li
                  key={addr.id}
                  onClick={() => {
                    onSelect(addr);
                    setShowModal(false);
                  }}
                  className="cursor-pointer hover:bg-gray-100 p-2 rounded"
                >
                  {addr.addressline1}, {addr.city}
                </li>
              ))}
            </ul>
            <button onClick={() => setShowModal(false)} className="mt-4 text-blue-500">Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddressSelector;
